/**
 * TipTap stores HTML. ICS-204 validation / export / non-TipTap consumers need
 * plain text with newlines preserved from block breaks.
 */
export function ics204HtmlToPlainText(html: string | null | undefined): string {
  if (!html) return '';
  const withBreaks = html
    .replace(/<\s*br\s*\/?>/gi, '\n')
    .replace(/<\s*\/\s*p\s*>/gi, '\n')
    .replace(/<\s*\/\s*div\s*>/gi, '\n')
    .replace(/<\s*\/\s*li\s*>/gi, '\n')
    .replace(/<\s*\/\s*h[1-6]\s*>/gi, '\n');
  const stripped = withBreaks.replace(/<[^>]+>/g, '');
  const decoded = stripped
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");
  return decoded.replace(/\n{3,}/g, '\n\n').trim();
}

/** TipTap empty docs are often `<p></p>` / `<p><br></p>`. */
export function isIcs204RichTextEmpty(
  html: string | null | undefined
): boolean {
  return ics204HtmlToPlainText(html).length === 0;
}
